import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings")({
  staticData: { title: "Settings" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/layout.tsx"),
    "SettingsLayout",
  ),
})
